// Project constants
export const APP_NAME = 'BerryStudio'
export const CONTACT_EMAIL = 'contact@berrystudio.ai'
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://berrystudio.ai'
export const DEMO_LINK = process.env.NEXT_PUBLIC_DEMO_LINK
export const PRACTICE_LOGIN_URL = process.env.NEXT_PUBLIC_PRACTICE_LOGIN_URL
export const ASSETS_URL = process.env.NEXT_PUBLIC_ASSETS_URL || '/'
export const CONTACT_US_FORM_LINK = process.env.NEXT_PUBLIC_CONTACT_US_FORM_LINK || ''
// Add more constants as needed


export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    BOOK_DEMO: '/book-demo',
    PRODUCTS: '/products',
    INITIATIVES: '/partners',
    PARTNERS: '/partners',
    TESTIMONIALS: '/testimonials',
    CONTACT: '/contact',
    CAREERS: '/careers',
}
